import PropTypes from "prop-types"
import "./style.scss"

export const LOADING_SIZES = ["page", "block", "inline"]

const CLASS_NAMES = {
  page: "components_loading",
  block: "components_loading-block",
  inline: "components_loading-inline",
}

function Loading({ size = "page" }) {
  // PropTypes only warn in dev, so an unrecognized size would ship an unstyled div.
  return <div className={CLASS_NAMES[size] ?? CLASS_NAMES.page}>
    <div>
      <i className="fa fa-circle-o-notch fa-spin fa-fw" />
      <span className="sr-only">Loading...</span>
    </div>
  </div>
}

Loading.propTypes = {
  // `page` fills a content area; `block` and `inline` impose no height, so they fit their container.
  size: PropTypes.oneOf(LOADING_SIZES),
}

export default Loading
